import React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';

export default styled(({ hasSuggestions, className, ...rest }) => (
  <input className={classnames(className, 'form-control')} autoComplete="street-address" {...rest} />
))`
  border-radius: ${({ hasSuggestions }) => (hasSuggestions ? '0.25rem 0.25rem 0 0' : '0.25rem')};
`;
